<template>
  <automasi v-if="valueName == 'eregistration'" />
  <beejak v-else-if="valueName == 'beejak'" />
  <ebilling v-else-if="valueName == 'ebilling'" />
  <ebupot v-else-if="valueName == 'ebupot'" />
  <ebupot v-else-if="valueName == 'ebupot-unifikasi'" />
  <efaktur v-else-if="valueName == 'efaktur'" />
  <efiling v-else-if="valueName == 'efiling'" />
  <espt-badan v-else-if="valueName == 'espt'" />
  <h2h v-else-if="valueName == 'h2h'" />
  <rekonsiliasi v-else-if="valueName == 'rekonsiliasi'" />
  <wapu v-else-if="valueName == 'efaktur-wapu'" />
  <training v-else-if="valueName == 'training'" />
  <verify v-else-if="valueName == 'verify'" />
  <invoice v-else-if="valueName == 'invoice'" />
  <ematerai v-else-if="valueName == 'ematerai'" />
  <taxomatic-pph v-else-if="valueName == 'ocr'" />
  <convert-to-csv v-else-if="valueName == 'convert-to-csv'" />
  <ctas-efaktur v-else-if="valueName == 'ctas-efaktur'" />
  <ctas-ebupot-unifikasi v-else-if="valueName == 'ctas-ebupot-unifikasi'" />
  <ctas-ebupot-pph21 v-else-if="valueName == 'ctas-ebupot-pph21'" />
  <genta v-else-if="valueName == 'genta'" />
</template>

<script>
import Automasi from "@/components/Icons/TaxApplication/Automasi";
import Beejak from "@/components/Icons/TaxApplication/Beejak";
import Ebilling from "@/components/Icons/TaxApplication/Ebilling";
import Ebupot from "@/components/Icons/TaxApplication/Ebupot";
import Efaktur from "@/components/Icons/TaxApplication/Efaktur";
import Efiling from "@/components/Icons/TaxApplication/Efiling";
import EsptBadan from "@/components/Icons/TaxApplication/EsptBadan";
import H2h from "@/components/Icons/TaxApplication/H2h";
import Rekonsiliasi from "@/components/Icons/TaxApplication/Rekonsiliasi";
import Training from "@/components/Icons/TaxApplication/Training";
import Wapu from "@/components/Icons/TaxApplication/Wapu";
import Verify from "@/components/Icons/TaxApplication/Verify";
import Invoice from "@/components/Icons/TaxApplication/Invoice";
import Ematerai from "@/components/Icons/TaxApplication/Ematerai";
import TaxomaticPph from "@/components/Icons/TaxApplication/TaxomaticPph";
import ConvertToCsv from "@/components/Icons/TaxApplication/ConvertToCsv";
import CtasEfaktur from "@/components/Icons/TaxApplication/CtasEfaktur";
import CtasEbupotUnifikasi from "@/components/Icons/TaxApplication/CtasEbupotUnifikasi";
import CtasEbupotPph21 from "@/components/Icons/TaxApplication/CtasEbupotPph21";
import Genta from "@/components/Icons/TaxApplication/Genta";

export default {
  components: {
    Automasi,
    Beejak,
    Ebilling,
    Ebupot,
    Efaktur,
    Efiling,
    EsptBadan,
    H2h,
    Rekonsiliasi,
    Training,
    Wapu,
    Verify,
    Invoice,
    Ematerai,
    TaxomaticPph,
    ConvertToCsv,
    CtasEfaktur,
    CtasEbupotUnifikasi,
    CtasEbupotPph21,
    Genta
  },
  props: {
    valueName: {
      type: [String],
    },
  },
};
</script>
